// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';
window.$ = jQuery;
import $ from 'jquery'; // Make sure this is removed and jQuery is used from the website
import { Link } from '../_modules/link/link';
import { Banner } from '../_modules/banner/banner';
import { Header } from '../_modules/header/header';
import { ConversationTile } from '../_modules/conversation-tile/conversation-tile';
import { Products } from '../_modules/products/products';

$(() => {
  new Link();
  new Banner(); 
  new ConversationTile();
  new Header();
  new Products();
  console.log('Welcome to Yeogurt!');
});
